module.exports = __webpack_public_path__ + "img/团城乡.57400379.png";